import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
// import Select from 'react-select'
import WorkPopup from "./WorkPopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { WorkMasterDeleteAPI, WorkMasterExportTableDataAPI, WorkMasterTableDataAPI } from "../../../../Redux/SidebarMasterSlice/WorkMasterSlice"
import { WorkTypeDDL } from "../../../../Components/CommonDDL/WorkTypeDDL"
import { WorkNameDDL } from "../../../../Components/CommonDDL/WorkNameDDL"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loading } from "../../../../Helper/Loading"
import { WorkSubTypeDDL } from "../../../../Components/CommonDDL/WorkSubTypeDDL"
import { useSearchParams } from "react-router-dom"
import { WorkExportData } from "./WorkExport"
import { ExcelWorkTypeEleMasterTableDataAPI, M_ELEC_Work_DeleteAPI, WorkTypeEleMasterTableDataAPI } from "../../../../Redux/ElectricalWorkTypeSlice/ElectricalWorkTypeSlice"
import { ElEWorkTypeDDL } from "../../../../Components/CommonDDL/ElEWorkTypeDDL"
import { ElEWorkSubTypeDDL } from "../../../../Components/CommonDDL/ElEWorkSubTypeDDL"
import { ElEWorkNameDDL } from "../../../../Components/CommonDDL/ElEWorkNameDDL"

export const Work = () => {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    const DashboardName = searchParams.get("DashboardName")

    const [WorkPopupShow, setWorkPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWorkPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setWorkPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWorkPopupShow(false)
    }

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkSubType, setWorkSubType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setCurrentPage(0)
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...'
        })
        setWorkName({
            ...WorkName,
            ID: 0,
            Label: 'Select...'
        })
        setWorkSubType({
            ...WorkSubType,
            ID: 0,
            Label: 'Select...'
        })
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [WorkType.ID, WorkName.ID, WorkSubType.ID])


    useEffect(() => {
        if (DashboardName == "Electrical") {
            const data = {
                M_ELEC_WorkID: WorkName?.ID,
                M_ELEC_WorkTypeID: WorkType.ID,
                M_ELEC_WorkSubTypeID: WorkSubType?.ID,
                WorkName: '',
                M_UserID: UserID,
                token: token,
                From: From,
                To: To,
            }
            dispatch(WorkTypeEleMasterTableDataAPI({ data }))
        } else {
            const data = {
                M_WorkID: WorkName.ID,
                M_WorkTypeID: WorkType.ID,
                M_WorkSubTypeID: WorkSubType.ID,
                M_WorkName: '',
                M_UsersID: UserID,
                token: token,
                From: From,
                To: To,
                handleWorkExport: handleWorkExport
            }
            dispatch(WorkMasterTableDataAPI({ data }))
        }
    }, [IsPost, To, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => DashboardName == "Electrical" ? state.WorkTypeEleMasterTableData : state.WorkMasterTableData)

    const handleWorkExport = () => {
        if (DashboardName == "Electrical") {
            const data = {
                M_ELEC_WorkID: WorkName?.ID,
                M_ELEC_WorkTypeID: WorkType.ID,
                M_ELEC_WorkSubTypeID: WorkSubType?.ID,
                WorkName: '',
                M_UserID: UserID,
                token: token,
                From: From,
                To: '99999',
            }
            dispatch(ExcelWorkTypeEleMasterTableDataAPI({ data }))
        } else {
            const data = {
                M_WorkID: WorkName.ID,
                M_WorkTypeID: WorkType.ID,
                M_WorkSubTypeID: WorkSubType.ID,
                M_WorkName: '',
                M_UsersID: UserID,
                token: token,
                From: From,
                To: '99999',
            }
            // if (WardName.ID !== 0) {
            dispatch(WorkMasterExportTableDataAPI({ data }))
        }
        // }
    }
    const { WorkExporttableData, isExportLoading } = useSelector(state => DashboardName == "Electrical" ? state.ExcelWorkTypeEleMasterTableData : state.WorkMasterExportTableData)

    const handleDeleteApi = (item) => {
        if (DashboardName == "Electrical") {
            const data = {
                M_ELEC_WorkID: item.m_eleC_WorkID,
                M_UserID: UserID,
                token: token,
                Flag: 'Delete',
                handleIsPost: handleIsPost
            }
            dispatch(M_ELEC_Work_DeleteAPI({ data }))
        } else {
            const data = {
                M_WorkId: item.m_WorkID,
                M_UserID: UserID,
                token: token,
                handleIsPost: handleIsPost
            }
            dispatch(WorkMasterDeleteAPI({ data }))
        }
    }
    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    return (
        <>
            {isLoading && <Loading />}

            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper ">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId} active='work' listActive={ProjectTypeId == 5 ? "gardenMaster" : ProjectTypeId == 8 ? "elec0trical" : "" } />
                    <div className="content">
                        {/* <!-- [ breadcrumb ] start --> */}
                        <div className="page-header ">
                            <div className="page-block">
                                <div className="row align-items-center">
                                    <div className="col-md-12">
                                        {/* <div className="page-header-title">
                                            <h5 className="ps-2 data_mob">MASTER */}
                                        {/* <!-- <span className="float-end">namita</span> --> */}
                                        {/* <span className="float-end fs-6">
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: SelectWard.ID, label: SelectWard.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setSelectWard({ ...SelectWard, ID: e.value, Label: e.label })
                                                            :
                                                            setSelectWard({ ...SelectWard, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={SelectWard.DDL}
                                                />

                                            </span> */}
                                        {/* </h5>

                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- [ Main Content ] start --> */}
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">

                                 <div className='col-12 row'>
                                    <div className="col-12 col-lg-5">
                                        <h5 className="ps-1 pt-2 ps-2">Work</h5>
                                    </div>

                                    <div className="col-12 col-lg-3">
                                        <h5 className="ps-1 py-1">Total Count =
                                            <text style={{ color: '#048A8B', fontSize: '18px' }}>
                                                &nbsp;{tableData && tableData.table && tableData.table.length > 0 && tableData.table[0]?.totalCount ? tableData.table[0]?.totalCount :'0'}
                                            </text>
                                        </h5>
                                    </div>

                                    <div className="col-12 col-lg-4 float-end mt-0 pt-1">
                                         {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                // GardenExporttableData && GardenExporttableData.table && GardenExporttableData.table.length
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <WorkExportData
                                                    ExcelData={WorkExporttableData}
                                                    name='Work'
                                                // searchName={searchName}
                                                />
                                        }

                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '0%' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>

                               
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row rounded2">
                                                {
                                                    DashboardName == "Electrical" ?
                                                        <>
                                                            <div className="col-12 col-md-4 col-lg-3">

                                                                <ElEWorkTypeDDL
                                                                    WorkType={WorkType}
                                                                    setWorkType={setWorkType}
                                                                    IsPost={IsPost}
                                                                    isDisplay={true}
                                                                    ApiFlag="Work_Wise_WorkType"
                                                                />
                                                            </div>

                                                            <div className="col-12 col-md-4 col-lg-3">

                                                                <ElEWorkSubTypeDDL
                                                                    WorkType={WorkType}
                                                                    WorkSubType={WorkSubType}
                                                                    setWorkSubType={setWorkSubType}
                                                                    IsPost={IsPost}
                                                                    isDisplay={true}
                                                                    ApiFlag="Work_Wise_WorkSubType"
                                                                />

                                                            </div>

                                                            <div className="col-12 col-md-4 col-lg-3">

                                                                <ElEWorkNameDDL
                                                                    WorkType={WorkType}
                                                                    WorkSubType={WorkSubType}
                                                                    WorkNameType={WorkName}
                                                                    setWorkNameType={setWorkName}
                                                                    IsPost={IsPost}
                                                                    isDisplay={true}
                                                                    ApiFlag="Master"
                                                                />

                                                            </div>

                                                        </>
                                                        :
                                                        <>
                                                            <div className="col-12 col-md-4 col-lg-3">
                                                                <WorkTypeDDL
                                                                    WorkType={WorkType}
                                                                    setWorkType={setWorkType}
                                                                    isDisplay={true}
                                                                />


                                                            </div>
                                                            <div className="col-12 col-md-4 col-lg-3">
                                                                <WorkSubTypeDDL
                                                                    WorkSubType={WorkSubType}
                                                                    setWorkSubType={setWorkSubType}
                                                                    WorkType={WorkType}
                                                                />

                                                            </div>
                                                            <div className="col-12 col-md-4 col-lg-3">
                                                                <WorkNameDDL
                                                                    WorkName={WorkName}
                                                                    setWorkName={setWorkName}
                                                                    WorkType={WorkType}
                                                                    WorkSubType={WorkSubType}
                                                                    IsPost={IsPost}
                                                                />
                                                            </div>
                                                        </>
                                                }
                                                <div className="col-12 col-lg-3 col-md-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>

                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Work Type</th>
                                                            <th>Work Sub Type</th>
                                                            <th>Work Name</th>
                                                            <th>Benchmark</th>
                                                            <th>Benchmark in <br /> Days</th>
                                                            <th>Penalty Amount <br /> (Rs.)</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* style={{width:'10%',whiteSpace:'nowrap',wordBreak:'break-all'}} */}
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                                                    <td>{item.workSubTypeName ? item.workSubTypeName : '-'}</td>
                                                                    {
                                                                        DashboardName == "Electrical" ?
                                                                            <>
                                                                                <td>{item.workName ? item.workName : '-'}</td>
                                                                                <td style={{ textAlign: "center" }}>{item.benchmark ? item.benchmark : '-'}</td>
                                                                                <td style={{ textAlign: "center" }}>{item.benchmark_In_Days ? item.benchmark_In_Days : '-'}</td>
                                                                                <td style={{ textAlign: "right" }}>{item.penaltyAmount ? (item.penaltyAmount).toFixed(2) : '-'}</td>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <td>{item.workname ? item.workname : '-'}</td>
                                                                                <td style={{ textAlign: "center" }}>{item.benchMark ? item.benchMark : '-'}</td>
                                                                                <td style={{ textAlign: "center" }}>{item.benchMarkinDays ? item.benchMarkinDays : '-'}</td>
                                                                                <td style={{ textAlign: "right" }}>{item.penaltyAmount ? (item.penaltyAmount).toFixed(2) : '-'}</td>
                                                                            </>
                                                                    }
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        {/* <WorkPopup
                                                                            open={WorkPopupShow}
                                                                            handleIsPost={handleIsPost}
                                                                            item={item}
                                                                            Flag='Update'
                                                                        /> */}
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <></>
                                                        }


                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {
                    WorkPopupShow ?
                        <WorkPopup
                            open={WorkPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashboardName={DashboardName}
                        />
                        : <></>
                }

            </div>
        </>
    )
}